<template>
  <div>
    <site-link
      :to="$search({ iconPacks: [hyphenatedFamilyName(familyName)], styles: styleName })"
      :class="[`card horizontal with-top-tag ${cardColor}`, { ' dark': isDarkTheme }]"
      style="height: 100%"
      @click.native="
        $posthog.capture(posthogCaptureName, {
          family: familyName,
          style: styleName
        })
      "
    >
      <div
        class="section text-left"
        style="align-self: flex-end; width: 5rem; min-width: 2rem"
      >
        <card-copy
          :card-color="cardColor"
          :family-name="familyName"
          :style-description="styleDescription"
          :style-name="styleName"
          :is-dark-theme="isDarkTheme"
        />
      </div>
      <span
        v-if="isNew"
        class="tag top secondary"
      >
        New
      </span>
      <div
        class="header padding-bottom-sm"
        style="clip-path: polygon(0% 0, 100% 0%, 1000% 100%, 30px 100%); flex-grow: 1"
      >
        <icon-grid
          :full-style-name="fullStyleName"
          :icons-row-one="cardIconsRowOne"
          :icons-row-two="cardIconsRowTwo"
          :icons-row-three="cardIconsRowThree"
          :is-vertical="false"
        />
      </div>
    </site-link>
  </div>
</template>

<script>
  import { getIconString, hyphenatedFamilyName } from './styleCardData.js'
  import CardCopy from './CardCopy'
  import IconGrid from './IconGrid'

  export default {
    name: 'StyleCardHorizontal',

    components: {
      CardCopy,
      IconGrid
    },

    props: {
      familyName: {
        type: String
      },
      cardColor: {
        type: String
      },
      styleDescription: {
        type: String
      },
      styleName: {
        type: String
      },
      fullStyleName: {
        type: String
      },
      isNew: {
        type: Boolean,
        default: false
      },
      isDarkTheme: {
        type: Boolean,
        default: false
      },
      posthogCaptureName: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        cardIconsRowOne: ['faBomb', 'faBug', 'faBalloons', 'faBicycle'],
        cardIconsRowTwo: ['faBookBookmark', 'faCat', 'faComet', 'faBagsShopping'],
        cardIconsRowThree: ['faChevronsUp', 'faCloudRainbow', 'faComment', 'faCherries']
      }
    },

    methods: {
      getIconString,
      hyphenatedFamilyName
    }
  }
</script>
